export class Motif {
    constructor(
        public id: number,
        public name: string,
        public src: string) { }
}
